<div class="global-spinner-container">
  <div class="hm-spinner"></div>
</div>
